import { BossApi, EventChannel } from "@bossvn/core";
import { message } from "antd";
import { globalEventBus } from "../globalEvent";
const channel = EventChannel.getInstance();
const isDEV = process.env.NODE_ENV === "development" || location.href.includes("localhost");
BossApi.BASE_URL = isDEV ? "" : process.env.NEXT_PUBLIC_CLIENT_API;
BossApi.NO_ENCRYPT = isDEV;
// 微前端环境配置
BossApi.API_PREFIX = isDEV ? "/api/proxy" : "";
// 获取当前语言
const getCurrentLanguage = () => {
    // 从URL路径检测语言
    const pathname = window.location.pathname;
    const languageMatch = pathname.match(/^\/(zh|en)/);
    if (languageMatch) {
        // 中文需要转换为zh-cn格式
        if (languageMatch[1] === "zh") {
            return "zh-cn";
        }
        return languageMatch[1];
    }
    // 如果没有语言前缀，默认为越南语
    return "vi-vn";
};
BossApi.EVENT_CODES = [1001053];
// 创建API实例
const api = new BossApi({
    channel,
    debugMode: process.env.NODE_ENV === "development",
    messageToast: message,
    event: globalEventBus,
});
// 包装request方法，自动添加Accept-Language头
const requestWithLanguage = (url, options = {}) => {
    const currentLang = getCurrentLanguage();
    // 确保headers存在
    if (!options.headers) {
        options.headers = {};
    }
    // 设置Accept-Language请求头
    options.headers["Accept-Language"] = currentLang;
    return api.request(url, options);
};
// 包装post方法
const postWithLanguage = (url, options = {}) => {
    const currentLang = getCurrentLanguage();
    if (!options.headers) {
        options.headers = {};
    }
    options.headers["Accept-Language"] = currentLang;
    return api.request(`${url}`, { method: "POST", ...options });
};
// 包装get方法
const getWithLanguage = (url, options = {}) => {
    const currentLang = getCurrentLanguage();
    if (!options.headers) {
        options.headers = {};
    }
    options.headers["Accept-Language"] = currentLang;
    return api.request(`${url}`, { method: "GET", ...options });
};
export { requestWithLanguage as request, postWithLanguage as post, getWithLanguage as get, };
